export default __webpack_public_path__ + "static/media/download_metamask_icon.527da712.svg";